import React from 'react';
import { Box } from '@hub/box';
import { useLocalUser } from '../../hooks/use-local-user';
import style from './index.module.scss';
import classNames from 'classnames';
import ClientOnly from '../client-only';
import SearchResults from './search-results';
import { processResults } from './algolia-helpers';
import { jsx as _jsx } from "react/jsx-runtime";
export const EmbeddedSearch = props => {
  const styles = [style.Search, style.wevoTheme];
  const {
    country,
    centre,
    centres,
    showFixedQuery,
    algoliaResults
  } = props;
  const user = useLocalUser();
  const baseContext = {
    user,
    centre,
    country,
    query: showFixedQuery
  };
  const {
    results,
    showNoResults
  } = processResults(showFixedQuery, baseContext, algoliaResults || {});
  const searchClassName = classNames(...styles);
  return /*#__PURE__*/_jsx(Box, {
    className: searchClassName,
    "data-id": "search_embedded-search_EmbeddedSearch_Box",
    children: /*#__PURE__*/_jsx(ClientOnly, {
      "data-id": "search_embedded-search_EmbeddedSearch_Box_ClientOnly",
      children: /*#__PURE__*/_jsx(SearchResults, {
        centres: centres,
        context: baseContext,
        isLoading: false,
        showNoResults: showNoResults,
        results: results,
        showFixedQuery: showFixedQuery,
        "data-id": "search_embedded-search_EmbeddedSearch_ClientOnly_SearchResults"
      })
    })
  });
};
export default EmbeddedSearch;